import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import Logo2 from "../../assets/Logo2.png";
import { useApi } from "../../hooks/api";
import {
  PageContainer,
  PageCard,
  PageHeader,
  PageBody,
  PageFooter,
  PageTitle,
  PageDescription,
  PageParagraph,
  PageLogo,
  ActionButtons,
  ActionButton,
} from "../shared/authLayout";

export const InvitationSurveyQualitative = () => {
  const [searchParams] = useSearchParams();
  const { api } = useApi();
  const [answered, setAnswered] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const invitationId = searchParams.get("invitation_id");
  const userId = searchParams.get("user_id");

//   if(!invitationId) return <Navigate to="/" />;

  useEffect(() => {
    if (!invitationId) return;

    api
      .get("/respondents/verify-invitation-depth-interview", {
        params: { invitationId, userId },
      })
      .catch((error) => console.error("Failed to verify invitation", error));
  }, [api, invitationId, userId]);

  const handleAnswer = async (userAccepted: boolean) => {
    setSubmitting(true);

    try {
      await api.post("/respondents/answer-invitation-depth-interview", {
        invitationId,
        userId,
        accepted: userAccepted,
      });
    } catch (error) {
      console.error("Failed to save answer", error);
    } finally {
      setAccepted(userAccepted);
      setAnswered(true);
      setSubmitting(false);
    }
  };

  return (
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageLogo src={Logo2} alt="Inside Brasil" />
          <PageTitle>
            {answered
              ? "Obrigado por responder!"
              : "Participe de uma entrevista qualitativa!"}
          </PageTitle>
        </PageHeader>

        <PageBody>
          {answered ? (
            <PageDescription>
              {accepted
                ? "Agradecemos seu interesse! Em breve nossa equipe entrará em contato com você."
                : "Agradecemos seu tempo."}
            </PageDescription>
          ) : (
            <>
              <PageParagraph>
                A Inside Brasil gostaria de convidar você para participar de uma
                entrevista qualitativa em profundidade.
              </PageParagraph>
              <PageParagraph>
                Sua opinião é muito importante para nós e ajudará a aprofundar os
                resultados da pesquisa.
              </PageParagraph>
              <PageParagraph>
                Ao aceitar este convite, você concorda que nosso time de analistas
                entre em contato para alinhar os detalhes e agendar a entrevista em
                um dia e horário que sejam convenientes para você.
              </PageParagraph>
              <PageParagraph>
                A participação é totalmente voluntária, e todas as informações serão
                tratadas com confidencialidade.
              </PageParagraph>
            </>
          )}
        </PageBody>

        {!answered && (
          <PageFooter>
            <ActionButtons>
              <ActionButton
                type="button"
                $variant="danger"
                disabled={submitting}
                onClick={() => handleAnswer(false)}
              >
                Recusar
              </ActionButton>
              <ActionButton
                type="button"
                disabled={submitting}
                onClick={() => handleAnswer(true)}
              >
                Aceitar
              </ActionButton>
            </ActionButtons>
          </PageFooter>
        )}
      </PageCard>
    </PageContainer>
  );
};
